import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outsource-students-data',
  templateUrl: './outsource-students-data.component.html',
  styleUrls: ['./outsource-students-data.component.css']
})
export class OutsourceStudentsDataComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
